import { ServicesState } from "@reducers/types/HRM/services-state";

import { ServicesActions } from "@actions/HRM/employee/services-actions";
import {
  GET_SERVICES,
  UPDATE_SERVICE_HISTORY_INFO,
  UPDATE_PROMOTION_PARTICULARS_INFO,
  UPDATE_OTHER_SERVICES_INFO,
  DELETE_SERVICE_HISTORY_INFO,
  DELETE_PROMOTION_PARTICULARS_INFO,
  DELETE_OTHER_SERVICES_INFO,
} from "@actions/HRM/employee/types";

import {
  getInitialState,
  getFailedState,
  getRequestingState,
  getSuccessState,
} from "@utils/store";

const initialState: ServicesState = { ...getInitialState() };

const resetStates = {
  updateServiceHistorySuccess: false,
  updateServiceHistoryFailed: false,

  updatePromotionParticularSuccess: false,
  updatePromotionParticularFailed: false,

  updateOtherServiceSuccess: false,
  updateOtherServiceFailed: false,

  deleteServicesHistorySuccess: false,
  deleteServicesHistoryFailed: false,

  deletePromotionParticularSuccess: false,
  deletePromotionParticularFailed: false,

  deleteOtherServiceSuccess: false,
  deleteOtherServiceFailed: false,
};

const servicesReducer = (
  state = initialState,
  action: ServicesActions,
): ServicesState => {
  switch (action.type) {
    case GET_SERVICES.GET_SERVICES_REQUEST: {
      return {
        ...getRequestingState({
          ...state,
          ...resetStates,
          getServicesRequestOngoing: true,
          getServicesSuccess: false,
          getServicesFailed: false,
        }),
      };
    }

    case GET_SERVICES.GET_SERVICES_SUCCESS: {
      const { payload } = action as any;
      return {
        ...getSuccessState({
          ...state,
          ...resetStates,
          data: payload.data,
          getServicesRequestOngoing: false,
          getServicesSuccess: true,
          getServicesFailed: false,
        }),
      };
    }

    case GET_SERVICES.GET_SERVICES_FAILED: {
      return {
        ...getFailedState({
          ...state,
          ...resetStates,
          getServicesRequestOngoing: false,
          getServicesSuccess: false,
          getServicesFailed: true,
        }),
      };
    }

    case UPDATE_SERVICE_HISTORY_INFO.UPDATE_SERVICE_HISTORY_INFO_REQUEST:
      return {
        ...getRequestingState({
          ...state,
          ...resetStates,
          updateServiceHistoryRequestOngoing: true,
          updateServiceHistorySuccess: false,
          updateServiceHistoryFailed: false,
        }),
      };

    case UPDATE_SERVICE_HISTORY_INFO.UPDATE_SERVICE_HISTORY_INFO_SUCCESS: {
      const { payload } = action as any;
      const currentServiceHistory =
        state && state.data ? state.data.serviceHistories : [];
      let updatedServiceHistory = currentServiceHistory;

      const indexOfNewServicesHistory = currentServiceHistory.findIndex(
        (serviceHistory: any) => serviceHistory.id === payload.data.id,
      );
      if (indexOfNewServicesHistory === -1)
        updatedServiceHistory.push(payload.data);
      else updatedServiceHistory[indexOfNewServicesHistory] = payload.data;

      const currentData = state.data;
      const updatedData = currentData || ({} as { [key: string]: any });
      updatedData["serviceHistories"] = updatedServiceHistory;

      return {
        ...getSuccessState({
          ...state,
          ...resetStates,
          data: updatedData,
          updateServiceHistoryRequestOngoing: false,
          updateServiceHistorySuccess: true,
          updateServiceHistoryFailed: false,
        }),
      };
    }

    case UPDATE_SERVICE_HISTORY_INFO.UPDATE_SERVICE_HISTORY_INFO_FAILED: {
      return {
        ...getFailedState({
          ...state,
          ...resetStates,
          updateServiceHistoryRequestOngoing: false,
          updateServiceHistorySuccess: false,
          updateServiceHistoryFailed: false,
        }),
      };
    }

    case UPDATE_PROMOTION_PARTICULARS_INFO.UPDATE_PROMOTION_PARTICULARS_INFO_REQUEST:
      return {
        ...getRequestingState({
          ...state,
          ...resetStates,
          updatePromotionParticularRequestOngoing: true,
          updatePromotionParticularSuccess: false,
          updatePromotionParticularFailed: false,
        }),
      };

    case UPDATE_PROMOTION_PARTICULARS_INFO.UPDATE_PROMOTION_PARTICULARS_INFO_SUCCESS: {
      const { payload } = action as any;
      const currentPromotionParticulars =
        state && state.data ? state.data.promotionParticulars : [];
      let updatedPromotionParticulars = currentPromotionParticulars;

      const indexOfNewPromotionParticulars =
        currentPromotionParticulars.findIndex(
          (promotionParticular: any) =>
            promotionParticular.id === payload.data.id,
        );
      if (indexOfNewPromotionParticulars === -1)
        updatedPromotionParticulars.push(payload.data);
      else
        updatedPromotionParticulars[indexOfNewPromotionParticulars] =
          payload.data;

      const currentData = state.data;
      const updatedData = currentData || ({} as { [key: string]: any });
      updatedData["promotionParticulars"] = updatedPromotionParticulars;

      return {
        ...getSuccessState({
          ...state,
          ...resetStates,
          data: updatedData,
          updatePromotionParticularRequestOngoing: false,
          updatePromotionParticularSuccess: true,
          updatePromotionParticularFailed: false,
        }),
      };
    }

    case UPDATE_PROMOTION_PARTICULARS_INFO.UPDATE_PROMOTION_PARTICULARS_INFO_FAILED: {
      return {
        ...getFailedState({
          ...state,
          ...resetStates,
          updatedromotionParticularRequestOngoing: false,
          updatedromotionParticularSuccess: false,
          updatePromotionParticularFailed: true,
        }),
      };
    }

    case UPDATE_OTHER_SERVICES_INFO.UPDATE_OTHER_SERVICES_INFO_REQUEST:
      return {
        ...getRequestingState({
          ...state,
          ...resetStates,
          updateOtherServiceRequestOngoing: true,
          updateOtherServiceSuccess: false,
          updateOtherServiceFailed: false,
        }),
      };

    case UPDATE_OTHER_SERVICES_INFO.UPDATE_OTHER_SERVICES_INFO_SUCCESS: {
      const { payload } = action as any;
      const currentOtherServicesInfo =
        state && state.data ? state.data.otherServices : [];
      let updatedOtherServices = currentOtherServicesInfo;

      const indexOfNewOtherServices = currentOtherServicesInfo.findIndex(
        (otherService: any) => otherService.id === payload.data.id,
      );
      if (indexOfNewOtherServices === -1)
        updatedOtherServices.push(payload.data);
      else updatedOtherServices[indexOfNewOtherServices] = payload.data;

      const currentData = state.data;
      const updatedData = currentData || ({} as { [key: string]: any });
      updatedData["otherServices"] = updatedOtherServices;

      return {
        ...getSuccessState({
          ...state,
          ...resetStates,
          data: updatedData,
          updateOtherServiceRequestOngoing: false,
          updateOtherServiceSuccess: true,
          updateOtherServiceFailed: false,
        }),
      };
    }

    case UPDATE_OTHER_SERVICES_INFO.UPDATE_OTHER_SERVICES_INFO_FAILED: {
      return {
        ...getFailedState({
          ...state,
          ...resetStates,
          updateOtherServiceRequestOngoing: false,
          updateOtherServiceSuccess: false,
          updateOtherServiceFailed: true,
        }),
      };
    }

    case DELETE_SERVICE_HISTORY_INFO.DELETE_SERVICE_HISTORY_INFO_REQUEST:
      return {
        ...getRequestingState({
          ...state,
          ...resetStates,
          deleteServicesHistoryRequestOngoing: true,
          deleteServicesHistorySuccess: false,
          deleteServicesHistoryFailed: false,
        }),
      };

    case DELETE_SERVICE_HISTORY_INFO.DELETE_SERVICE_HISTORY_INFO_SUCCESS: {
      const { payload } = action as any;
      const updatedServiceHistoryInfo =
        state && state.data && state.data.serviceHistories
          ? state.data.serviceHistories.filter(
              (serviceHistory: any) => serviceHistory.id !== payload.data.id,
            )
          : [];

      const currentData = state.data;
      const updatedData = currentData || ({} as { [key: string]: any });
      updatedData["serviceHistories"] = updatedServiceHistoryInfo;

      return {
        ...getRequestingState({
          ...state,
          ...resetStates,
          data: updatedData,
          deleteServicesHistoryRequestOngoing: false,
          deleteServicesHistorySuccess: true,
          deleteServicesHistoryFailed: false,
        }),
      };
    }

    case DELETE_SERVICE_HISTORY_INFO.DELETE_SERVICE_HISTORY_INFO_FAILED: {
      return {
        ...getFailedState({
          ...state,
          ...resetStates,
          deleteServicesHistoryRequestOngoing: false,
          deleteServicesHistorySuccess: false,
          deleteServicesHistoryFailed: true,
        }),
      };
    }

    case DELETE_PROMOTION_PARTICULARS_INFO.DELETE_PROMOTION_PARTICULARS_INFO_REQUEST:
      return {
        ...getRequestingState({
          ...state,
          ...resetStates,
          deletePromotionParticularRequestOngoing: true,
          deletePromotionParticularSuccess: false,
          deletePromotionParticularFailed: false,
        }),
      };

    case DELETE_PROMOTION_PARTICULARS_INFO.DELETE_PROMOTION_PARTICULARS_INFO_SUCCESS: {
      const { payload } = action as any;
      const updatedPromotionParticularsInfo =
        state && state.data && state.data.promotionParticulars
          ? state.data.promotionParticulars.filter(
              (promotionParticulars: any) =>
                promotionParticulars.id !== payload.data.id,
            )
          : [];
      const currentData = state.data;
      const updatedData = currentData || ({} as { [key: string]: any });
      updatedData["promotionParticulars"] = updatedPromotionParticularsInfo;

      return {
        ...getRequestingState({
          ...state,
          ...resetStates,
          data: updatedData,
          deletePromotionParticularRequestOngoing: false,
          deletePromotionParticularSuccess: true,
          deletePromotionParticularFailed: false,
        }),
      };
    }

    case DELETE_PROMOTION_PARTICULARS_INFO.DELETE_PROMOTION_PARTICULARS_INFO_FAILED: {
      return {
        ...getFailedState({
          ...state,
          ...resetStates,
          deletePromotionParticularsRequestOngoing: false,
          deletePromotionParticularsSuccess: false,
          deletePromotionParticularFailed: true,
        }),
      };
    }

    case DELETE_OTHER_SERVICES_INFO.DELETE_OTHER_SERVICES_INFO_REQUEST:
      return {
        ...getRequestingState({
          ...state,
          ...resetStates,
          deleteOtherServiceRequestOngoing: true,
          deleteOtherServiceSuccess: false,
          deleteOtherServiceFailed: false,
        }),
      };

    case DELETE_OTHER_SERVICES_INFO.DELETE_OTHER_SERVICES_INFO_SUCCESS: {
      const { payload } = action as any;
      const updatedOtherServicesInfo =
        state && state.data && state.data.otherServices
          ? state.data.otherServices.filter(
              (otherService: any) => otherService.id !== payload.data.id,
            )
          : [];

      const currentData = state.data;
      const updatedData = currentData || ({} as { [key: string]: any });
      updatedData["otherServices"] = updatedOtherServicesInfo;

      return {
        ...getRequestingState({
          ...state,
          ...resetStates,
          data: updatedData,
          deleteOtherServiceRequestOngoing: false,
          deleteOtherServiceSuccess: true,
          deleteOtherServiceFailed: false,
        }),
      };
    }

    case DELETE_OTHER_SERVICES_INFO.DELETE_OTHER_SERVICES_INFO_FAILED: {
      return {
        ...getFailedState({
          ...state,
          ...resetStates,
          deleteOtherServiceRequest: false,
          deleteOtherServiceSuccess: false,
          deleteOtherServiceFailed: true,
        }),
      };
    }

    default:
      return state;
  }
};

export default servicesReducer;
